var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F52A4402-4E9E-4797-8B8E-D8DDED1C9197") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-transporter",
    transform: "translate(-461.000000, -10.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(461.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#519CEC",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    x: 3.5,
    y: 3.5,
    width: 73,
    height: 73,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(14.000000, 9.000000)",
    fill: "#FFFFFF",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6441967,51.6967213 L49.6924367,51.6967213 C51.2192447,51.6967213 52.4569672,52.9344438 52.4569672,54.4612519 C52.4569672,55.9880599 51.2192447,57.2257824 49.6924367,57.2257824 L43.6441967,57.2257824 L43.6441967,60.6814456 L42.3852295,60.6814456 L42.3852295,51.6967213 L43.6441967,51.6967213 Z M43.6441967,52.664307 L43.6441967,56.1199702 L49.4701684,56.1199702 C50.4244234,56.1199702 51.198,55.3463936 51.198,54.3921386 C51.198,53.4378836 50.4244234,52.664307 49.4701684,52.664307 L43.6441967,52.664307 Z M27.4175082,51.6967213 L27.8409655,51.6967213 L33.3039965,59.4374069 L38.6584843,51.6967213 L39.1678689,51.6967213 L40.4268361,51.6967213 L40.4268361,60.6814456 L39.1678689,60.6814456 L39.1678689,52.9629823 L33.8079357,60.6814456 L32.8121176,60.6814456 L27.4175082,52.9914715 L27.4175082,60.6814456 L26.158541,60.6814456 L26.158541,51.6967213 L27.4175082,51.6967213 Z M14.5480656,59.4374069 L21.4024426,59.4374069 L21.4024426,60.6814456 L14.5480656,60.6814456 L13.2890984,60.6814456 L13.2890984,51.6967213 L14.5480656,51.6967213 L14.5480656,59.4374069 Z M22.8012951,51.6967213 L24.0602623,51.6967213 L24.0602623,60.6814456 L22.8012951,60.6814456 L22.8012951,51.6967213 Z M4.56147541,51.6967213 L6.90911475,51.6967213 C9.42834806,51.6967213 11.4705902,53.7389634 11.4705902,56.2581967 C11.4705902,58.77743 9.42834806,60.8196721 6.90911475,60.8196721 L4.56147541,60.8196721 C2.0422421,60.8196721 3.085171e-16,58.77743 0,56.2581967 C-3.085171e-16,53.7389634 2.0422421,51.6967213 4.56147541,51.6967213 Z M4.7146304,52.8025335 C2.80612032,52.8025335 1.25896721,54.3496866 1.25896721,56.2581967 C1.25896721,58.1667068 2.80612032,59.7138599 4.7146304,59.7138599 L6.89584501,59.7138599 C8.80435509,59.7138599 10.3515082,58.1667068 10.3515082,56.2581967 C10.3515082,54.3496866 8.80435509,52.8025335 6.89584501,52.8025335 L4.7146304,52.8025335 Z",
    id: "Combined-Shape",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8483607,47.1352459 C12.8323219,47.1352459 2.2807377,36.5836617 2.2807377,23.567623 C2.2807377,10.5515842 12.8323219,0 25.8483607,0 C38.8643994,0 49.4159836,10.5515842 49.4159836,23.567623 C49.4159836,36.5836617 38.8643994,47.1352459 25.8483607,47.1352459 Z M25.8483607,44.9171167 C37.6393605,44.9171167 47.1978544,35.3586228 47.1978544,23.567623 C47.1978544,11.7766231 37.6393605,2.21812922 25.8483607,2.21812922 C14.0573609,2.21812922 4.49886692,11.7766231 4.49886692,23.567623 C4.49886692,35.3586228 14.0573609,44.9171167 25.8483607,44.9171167 Z",
    id: "Combined-Shape",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.961251,2.22546766 L26.4535693,1.5204918 L45.6147541,34.606075 L45.6147541,36.4918033 L8.71337055,36.4918033 L6.84221311,35.5970226 L25.961251,2.22546766 Z M26.4402509,5.66819382 L9.9817709,34.3432953 L42.9916366,34.3432953 L26.4402509,5.66819382 Z",
    id: "Combined-Shape",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bcfac1ef35894a1889c7ae2956ad813d.svg";
export { ForwardRef as ReactComponent };